import * as Segment from '/@/integrations/segment';
import { IdentifyTraitsProperties } from '@/integrations/segment/types/IdentifyTraitsProperties';
import { Env } from '@/Env';
export class SegmentHelper {
  init(): void {
    // @ts-ignore
    Segment.init(Env.nodeEnv().VITE_APP_SEGMENT_API_KEY);
  }

  track(eventName: string, properties: Record<string, unknown>): void {
    // @ts-ignore
    window.analytics?.track(eventName, properties);
  }

  page(name: string, properties: Record<string, unknown>, options: Record<string, unknown>): void {
    // @ts-ignore
    window.analytics?.page(name, properties, options);
  }

  alias(userId: number): void {
    // @ts-ignore
    window.analytics?.alias(userId);
  }

  identify(userId: number | null, traits: IdentifyTraitsProperties): void {
    // @ts-ignore
    window.analytics?.identify(userId, traits);
  }

  reset(): void {
    // @ts-ignore
    window.analytics?.reset();
    // @ts-ignore
    window.mixpanel?.reset();
  }

  encodeTrackingUrlValue(trackingProperties: Record<string, unknown> = {}): string {
    return btoa(JSON.stringify(trackingProperties));
  }

  decodeTrackingUrlValue(trackingUrlValue: string = ''): Record<string, unknown> {
    return JSON.parse(atob(trackingUrlValue) ?? '{}');
  }
}

export default new SegmentHelper();
